import {Card, Divider, Typography, Menu, Button, Row, Col} from "antd";
import type { MenuProps } from 'antd';
import React, {useEffect, useState} from "react";
import ApplicationTable from "@modules/Recruiting/Interview/ApplicationTable";
import api from "../services/api";
import { useNavigate } from "react-router-dom";


const { Title } = Typography;

type SubmissionProps = {
	title: string;
};

const ApplicationsArchive = (props: SubmissionProps) => {
	const [fetchApplication, setFetchApplication] = useState<any>([]);

	const [archive, setArchive] = useState<any>();

	const [requestCurrentPage, setRequestCurrentPage] = useState<number>(1);
	const [menuItems, setMenuItems] = useState<{label: string, key: string}[]>([{label: '-', key: '-'}]);
	const [current, setCurrent] = useState<string>('');

	const { title } = props;

	const navigate = useNavigate();

	useEffect(() => {
		document.title = title;
	}, [title]);

	const getMyArchive = async () => {
		const { data } = await api.getMyApplicationData();
		return data?.data?.archived;
	};

	useEffect(() => {
		getMyArchive().then((values) => setArchive(values));
	}, []);

	useEffect(() => {
		if (archive !== null && archive !== undefined) {
			const archiveYears = Object.keys(archive);

			const numberYears = archiveYears.map((year) => Number(year));
			const sortedYears = archiveYears.sort((a: string,b: string) => (a > b ? -1 : 1));
			const items = sortedYears.map((year) => {
				return {
					label: year,
					key: year
				}
			});
			setMenuItems(items);
			const defaultYear = archiveYears[0];
			setCurrent(defaultYear);
			setFetchApplication(archive[defaultYear]);
		};
	}, [archive]);


	const onClick: MenuProps ['onClick'] = (e) => {
		setCurrent(e.key);
		setFetchApplication(archive[e.key]);
	};

	return (
		<>
			<Card style={{ marginTop: 25, marginBottom: 400 }}>
				<Row>
					<Button
						onClick={() => navigate('/recruiting')}
					>
						Назад
					</Button>
				</Row>
				<Row 
					style ={{
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
					}}
				>
					<Col xs={8} sm={3} style={{marginBottom: '15px'}}>
						<Title level={4} style={{ color: '#0057FF', margin: '0', width: '130px', marginRight: '10px' }}>
							Архив
						</Title>
					</Col>

					<Col xs={16} sm={18} style={{marginBottom: '15px'}}>
						<Menu 
							className='applications-menu' 
							style={{width: '100%'}}
							onClick={onClick} 
							selectedKeys={[current]} 
							mode="horizontal" 
							items={menuItems} 
						/>
					</Col>
					
				</Row>
				
				<Divider />

				<ApplicationTable
					fetchApplication={fetchApplication}
					currentPage={requestCurrentPage}
					setCurrentPage={setRequestCurrentPage}
				/>
			</Card>
		</>
	);
};

export default ApplicationsArchive;
